import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { BuildAvatarModule } from '@portal-core/builds/components/build-avatar/build-avatar.module';
import { BuildAsyncModule } from '@portal-core/builds/pipes/build-async/build-async.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { PreventDefaultModule } from '@portal-core/general/directives/prevent-default/prevent-default.module';
import { SiteAccessFormModule } from '@portal-core/sites/components/site-access-form/site-access-form.module';
import { SiteAvatarModule } from '@portal-core/sites/components/site-avatar/site-avatar.module';
import { SiteDeletionFormModule } from '@portal-core/sites/components/site-deletion-form/site-deletion-form.module';
import { SiteSettingsFormModule } from '@portal-core/sites/components/site-settings-form/site-settings-form.module';
import { SwitchBoardModule } from '@portal-core/ui/switch-board/switch-board.module';
import { SiteProfileDialogComponent } from './site-profile-dialog.component';

@NgModule({
  declarations: [SiteProfileDialogComponent],
  imports: [
    BuildAvatarModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    LoaderModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatTabsModule,
    MatListModule,
    SiteAvatarModule,
    PreventDefaultModule,
    SiteSettingsFormModule,
    SiteDeletionFormModule,
    SwitchBoardModule,
    BuildAsyncModule,
    SiteAccessFormModule
  ],
  exports: [SiteProfileDialogComponent]
})
export class SiteProfileDialogModule { }
